import InstructorUtilizationModule from "./InstructorUtilization";
import Saga from "../common/saga";
import { createReducer } from "../common/createReducer";

export default {
  Component: InstructorUtilizationModule,
  moduleName: "instructorUtilization",
  saga: Saga("instructorUtilization"),
  reducer: createReducer("instructorUtilization")
};
